import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/authProvider';
import { createGlobalStyle } from 'styled-components';

// Define a GlobalStyle component that accepts a theme prop
const GlobalStyle = createGlobalStyle`
  body {
    /* background-color: white;responisveness converter */
    /* Add other body styles here, each using the theme prop */
  }
`;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <GlobalStyle />
        <App />
      </BrowserRouter> 
    </AuthProvider>
  </React.StrictMode>
);